export enum MessageType {
  System = 0,
  Text = 1,
  Media = 2,
}
